import React from "react";
import "./style.css";
import projectIcon from "../../assets/icons/project-icon.svg";
import aboutIcon from "../../assets/icons/about-me.svg";
import { IconContext } from "react-icons";
import { GrLinkedinOption } from "react-icons/gr";
import { FaGithub } from 'react-icons/fa';
import { FaEnvelope } from "react-icons/fa";
import {
  Name,
  StyledButtonsContainer,
  StyledHome,
  Title,
  Line,
  Greeting,
  Social,
  Socials,
  Quote,
} from "../../style/home/HomeStyles";
import { StyledButton } from "../../style/button/ButtonStyles";

const Home = () => {
  let today = new Date();
  let hour = today.getHours();
 
  return (
    <IconContext.Provider value={{ size: "1rem" }}>
      <StyledHome id="home">
        <Name>
          <span className="iam"> Hello 👋, I'm</span>
          <br />
          Pradeep Kumar Dhital
        </Name>
        <Title>Full Stack Developer</Title>

        <p>
          I <span className="change-text"></span>{" "}
          <span className="responsive">r</span>
          <span className="responsive">e</span>
          <span className="responsive">s</span>
          <span className="responsive">p</span>
          <span className="responsive">o</span>
          <span className="responsive">n</span>
          <span className="responsive">s</span>
          <span className="responsive">i</span>
          <span className="responsive">v</span>
          <span className="responsive">e</span> full stack web applications.
        </p>
        <StyledButtonsContainer>
          <StyledButton
            icon={projectIcon}
            to="projects"
            smooth={true}
            duration={0}
            delay={0}
            spy={true}
            spyThrottle={0}
            exact="true"
            offset={-50}
          >
            <span>Projects</span>
          </StyledButton>
          <StyledButton
            icon={aboutIcon}
            secondary="true"
            content="B"
            to="about"
            smooth={true}
            duration={0}
            delay={0}
            spy={true}
            spyThrottle={0}
            exact="true"
            offset={-50}
          >
            <span>About me</span>
          </StyledButton>
        </StyledButtonsContainer>
        <Line />
        <Greeting>
          Wishing you a great
          <span>
            {hour < 4
              ? " night 🌙"
              : hour < 12
              ? " morning ☕"
              : hour < 17
              ? " day ☀️"
              : hour < 21
              ? " evening 🌙"
              : " night 🌙"}
          </span>
        </Greeting>
        <Socials>
          <Social
            href="mailto:pradeepdhital124@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaEnvelope />
          </Social>
          <Social
            href="https://github.com/Pradeep22222"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithub />
          </Social>
          <Social
            href="https://www.linkedin.com/in/pradeepkumardhital/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GrLinkedinOption />
          </Social>
        </Socials>
        <Quote className="quote">""Donot just wish, act!!""</Quote>
      </StyledHome>
    </IconContext.Provider>
  );
};

export default Home;
